import React, { useEffect, useLayoutEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { MobilePlatform } from "@state/stores/types";
import { redirectUserToHomePageAfterRegistration } from "@utils";
import { useRootAppStore } from "@hooks";
import useDynamicMinHeight from "@hooks/useDynamicMinHeight ";
import { OnBoardingSlider } from "../shared";

export default function RegistrationError() {
	const { pageStore } = useRootAppStore<MobilePlatform>();
	const { t } = useTranslation("registration");
	const formRef = useRef<HTMLDivElement>(null);
	const minHeight = useDynamicMinHeight();

	const redirectToHomePage = () => {
		redirectUserToHomePageAfterRegistration();
	};

	useLayoutEffect(() => {
		pageStore.setMinimalPageHeader();
	}, []);

	/* useEffect(() => {
		if (formRef.current) {
			const minHeightValue = Math.max(minHeight);
			formRef.current.style.height = `${minHeightValue}px`;
		}
	}, [minHeight]);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []); */

	return (
		<div className="container">
			<div className="section--membership">
				<OnBoardingSlider />

				<div className="section--membership__form" ref={formRef}>
					<div className="section--membership__header u-display--f--col">
						<i className="u-icon u-icon--xlrg u-icon--remove-circle u-icon--animated--bounce-in u-color--sent--danger" />
						<div className="section--membership__title">
							{t("ERROR_HAS_OCCURED")}
						</div>
					</div>

					<div className="section--membership__content section--membership__message u-type--center">
						{t("GENERIC_ERROR")}
					</div>

					<button
						type="button"
						className="at-regErrorBtn btn btn--base btn--block btn--accent"
						onClick={redirectToHomePage}
					>
						{t("COMMON.OK_BTN")}
					</button>
				</div>
			</div>
		</div>
	);
}
